import React from 'react'
import styled from 'styled-components'
import { v4 as uuidV4 } from 'uuid'

import Text from '@/components/atomic/atoms/Text'
import Icon from '@/components/cell/atoms/Icon'
import { IconPack } from '@/components/cell/atoms/Icon/enum'
import COLOR from '@/components/cell/designTokens/color'

export interface Props {
  /** checkbox 체크상태 */
  checked: boolean
  /** checkbox 체크상태 */
  onChangeCheckbox: (checked: boolean) => void
  /** children */
  children?: React.ReactNode | string
  id?: string
}

const Checkbox = ({ checked, onChangeCheckbox, children, id }: Props): JSX.Element => {
  const idValue = id || uuidV4()
  return (
    <StyledContainer>
      <StyledCheckbox
        id={idValue}
        type="checkbox"
        data-testid={checked ? 'general-action-checkbox-on' : 'general-action-checkbox-off'}
        checked={checked}
        onChange={() => onChangeCheckbox(!checked)}
      />
      <StyledLabel id={id + '-label'} htmlFor={idValue}>
        {checked ? (
          <Icon name={IconPack.GENERAL_ACTION_CHECKBOX_ON} />
        ) : (
          <Icon name={IconPack.GENERAL_ACTION_CHECKBOX_OFF} />
        )}
        <Text element="span" type="description2" data-testid="general-checkbox-label">
          {children || ''}
        </Text>
      </StyledLabel>
    </StyledContainer>
  )
}

const StyledContainer = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
`

const StyledLabel = styled.label`
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 10.5px;
  padding: 0 10.5px;
`

const StyledCheckbox = styled.input`
  span {
    font-weight: bold;
    color: ${COLOR.gray800};
  }
  // hide default checkbox
  appearance: none;
`

export default Checkbox
